﻿/*************** SIDEBAR HANDLER BEGIN ***********************/

function sideBarHandler() {
    const sidebarTogglers = document.querySelectorAll('.has-children .arrow.right');
    const currentSidebarItem = document.querySelector('.sidebar-accordion .current_page_item');

    if (sidebarTogglers === 0) return;

    // NEW: if view already rendered something expanded, don't touch it
    const alreadyExpanded = document.querySelector('.sidebar-accordion .accordion-sub-menu.expanded');
    if (!alreadyExpanded && currentSidebarItem) {
        expandSidebarToCurrentItem(currentSidebarItem);
    }

    sidebarTogglers.forEach(toggler => {
        toggler.addEventListener('click', toggleSidebarSubMenu);
    });
}


function toggleSidebarSubMenu(event) {

    const currentSidebarMenu = event.target.closest('.has-children');

    if (!currentSidebarMenu) {
        return;
    }

    const subMenu = currentSidebarMenu.querySelector('.accordion-sub-menu');

    if (!subMenu) {
        return;
    }

    subMenu.classList.toggle('expanded');
    event.target.classList.toggle('active');
}


function expandSidebarToCurrentItem(currentSidebarItem) {

    let parent = currentSidebarItem.closest('.accordion-sub-menu');

    if (!parent) {
        return;
    }

    while (parent !== null) {
        let currentParent = parent;
        const dropDownItem = currentParent.closest('.has-children');

        if (dropDownItem) {
            dropDownItem.querySelector('.arrow').classList.add('active');
        }

        currentParent.classList.add('expanded');
        parent = dropDownItem.closest('.accordion-sub-menu');
    }

}

sideBarHandler();

/*************** SIDEBAR HANDLER END ***********************/
